import React, { useState, useEffect } from "react";
import { FaUserCircle } from "react-icons/fa";
import { AiOutlinePlus, AiOutlineCheck } from "react-icons/ai";
import { fetch_myfriends_invites, post_inv_friends_mylobby, delete_inv_friends_mylobby, post_create_lobby } from "../../Api";

const InviteFriends = ({ maxCount = 1, onClose }) => {
  const [friends, setFriends] = useState([]);
  const [localSelected, setLocalSelected] = useState([]);

  useEffect(() => {
    const init = async () => {
      try {
        const res = await post_create_lobby();

        console.log("Lobby created:", res);
      } catch (err) {
        alert(err.response?.data?.detail?.message || "Something went wrong");
        return;

      }

      // Always fetch friends, regardless of lobby creation result
      try {
        const data = await fetch_myfriends_invites();
        setFriends(data);
      } catch (err) {
        console.error("Failed to fetch friends:", err);
        setFriends([]);
      }
    };

    init();
  }, []);


  const handleSelect = (friend) => {
    if (isSelected(friend.id)) return;
    if (localSelected.length >= maxCount) return;
    setLocalSelected((prev) => [...prev, friend]);
  };

  const isSelected = (id) => localSelected.some((f) => f.id === id);

  return (
    <div className="p-3">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Invite Friends</h5>
        <button className="btn btn-sm btn-outline-secondary" onClick={onClose}>
          Close
        </button>
      </div>

      {/* Friend List */}

      <div className="list-group">
        {friends
          .filter(friend => friend.invite_status !== "accepted")
          .map((friend) => {
            const selected = isSelected(friend.id);
            return (
              <div
                key={friend.id}
                className="list-group-item d-flex align-items-center justify-content-between"
              >
                {/* Avatar + Name */}
                <div className="d-flex align-items-center">
                  {friend.profile_image ? (
                    <img
                      src={`${friend.profile_image}`}
                      alt={friend.full_name}
                      className="rounded-circle me-3"
                      style={{ width: 48, height: 48, objectFit: "cover" }}
                    />
                  ) : (
                    <FaUserCircle
                      size={48}
                      className="me-3 text-muted"
                    />
                  )}
                  <div className="fw-semibold">{friend.full_name}</div>
                </div>

                {/* Action button */}
                {friend.invited || selected ? (
                  <div className="d-flex align-items-center">
                    <span className="text-success d-flex align-items-center me-2">
                      <AiOutlineCheck className="me-1" /> Invited
                    </span>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={async () => {
                        try {
                          await delete_inv_friends_mylobby(friend.id);
                          setFriends((prev) =>
                            prev.map((f) =>
                              f.id === friend.id ? { ...f, invited: false } : f
                            )
                          );
                        } catch (err) {
                          console.error("Failed to cancel invite:", err);
                        }
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                ) : (
                  <button
                    className="btn btn-sm btn-outline-primary d-flex align-items-center"
                    onClick={async () => {
                      try {
                        await post_inv_friends_mylobby(friend.id);
                        setFriends((prev) =>
                          prev.map((f) =>
                            f.id === friend.id ? { ...f, invited: true } : f
                          )
                        );
                      } catch (err) {
                        console.error("Failed to invite friend:", err);
                      }
                    }}
                  >
                    <AiOutlinePlus className="me-1" /> Invite
                  </button>
                )}
              </div>
            );
          })}
      </div>



    </div>
  );

};

export default InviteFriends;
